
























































































































import {
  Vue,
  Component, Watch
} from "@/shared/vuepack";
import {
  DrivewealthAccountSummary,
  DrivewealthAccountManagementType,
  DrivewealthWizardStep,
  AccountCloseReasonResponse,
  AccountCloseReasonModel
} from "@/shared/types";
import VueRouter from "vue-router";
import _ from "lodash";
import * as RouteNames from "@/employee/route-names";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useNotifierStore } from "@/shared/store/notifier";
import { useThemeStore } from "@/shared/store/theme";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsaInvestAccountList extends Vue {
  drivewealthStore = useDrivewealthStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  impersonatorStore = useImpersonatorStore();
  custodianSettingsStore = useCustodianSettingsStore();

  $router: VueRouter;

  closeAccountProcessing = false;
  isCloseButtonDisabled = false;
  showConfirmCloseModal = false;
  confirmCloseText = "";
  selectedDrivewealthAccountId = 0;
  accountCloseReasonId = 0;
  customReasonText = "";
  otherReason: AccountCloseReasonResponse =
    {
      accountCloseReasonId: -1,
      description: "Other (please specify)"
    };

  tableFields = [
    {
      key: "accountManagementType",
      label: "Investment Option Type",
      thClass: "text-left",
    },
    {
      key: "accountNumber",
      label: "Account Number",
      thClass: "text-left"
    },
    {
      key: "drivewealthAccountId",
      label: "",
      thClass: "text-left"
    },
  ];

  mounted (): void {
    _.forEach(this.drivewealthAccounts, x => {
      this.drivewealthStore.loadPendingActivityByAccount({
        username: null,
        partnerId: null,
        accountId: x.drivewealthAccountId
      });
    });
    this.loadSignedDocumentKeys();
    this.drivewealthStore.getAccountCloseReasons();
  }

  get drivewealthAccounts (): DrivewealthAccountSummary[] {
    return this.drivewealthStore.accountSummariesV2;
  }

  get accountCloseReasons (): AccountCloseReasonResponse[] {
    return this.drivewealthStore.accountCloseReasons;
  }

  get hsaInvestEnrollButtonDisabled (): boolean {
    return this.custodianSettingsStore.hsaInvestEnrollButtonDisabled;
  }

  toggleMask (account): void {
    this.$set(account, "_unMasked", !account._unMasked);
  }

  formatAccountNumber (account): string {
    if (account._unMasked) {
      return account.accountNumber;
    }
    return "•".repeat(account.accountNumber.length);
  }

  get showAddAccountButton (): boolean {
    return this.drivewealthStore.canOpenAnotherInvestmentAccount;
  }

  get displayAccountNumberToggleButton (): boolean {
    if (!this.featureFlagStore.flags.bend24505HideInvestmentAccountNumberMaskButtonForImpersonation) {
      return true;
    }

    return !this.impersonatorStore.impersonationIsActive;
  }

  addInvestmentAccount (): void {
    this.$router.push(
        { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.SelectAccountType } });
  }

  hasHoldings (accountId: number): boolean {
    const accountSummary = this.drivewealthStore.accountSummaryById(accountId);

    if (accountSummary) {
      return accountSummary.holdings && accountSummary.holdings.length > 0;
    }

    return false;
  }

  hasInvestmentBalance (accountId: number): boolean {
    const account = this.drivewealthStore.accountSummaryById(accountId);

    if (account) {
      return account.displayBalance > 0;
    }
    return true;
  }

  hasPendingActivity (accountId: number): boolean {
    const pendingActivityLoaded = this.drivewealthStore.pendingActivityV2Loaded(accountId);
    const pendingActivityForAccount = this.drivewealthStore.pendingActivityById(accountId);
    const account = this.drivewealthStore.accountSummaryById(accountId);

    return pendingActivityLoaded &&
        pendingActivityForAccount.pendingOrders.length > 0;
  }

  disableCloseButton (accountId: number): boolean {
    return this.hasInvestmentBalance(accountId) ||
      this.hasHoldings(accountId) ||
      this.hasPendingActivity(accountId) ||
      this.drivewealthStore.closeAccountLoading ||
      this.isCloseButtonDisabled;
  }

  get disableCloseConfirmSubmit (): boolean {
    return (this.accountCloseReasonId !== this.otherReason.accountCloseReasonId && this.accountCloseReasons.every(x => x.accountCloseReasonId !== this.accountCloseReasonId));
  }

  get accountTypeKeys (): DrivewealthAccountManagementType[] {
    return this.drivewealthStore.accountIds.map(x => {
      return this.drivewealthStore.accountManagementType(x);
    });
  }

  @Watch("accountTypeKeys", { deep: true })
  loadSignedDocumentKeys (): void {
    this.accountTypeKeys.forEach(x => {
      this.signingDocumentStore.getSignedDocumentKey(x);
    });
  }

  documentKey (accountId: number): DrivewealthAccountManagementType {
    const accountTypeKey = this.drivewealthStore.accountManagementType(accountId);
    const signedKey = this.signingDocumentStore.signedKey(accountTypeKey);
    return signedKey.documentKey;
  }

  onModalClose (): void {
    this.showConfirmCloseModal = false;
    this.confirmCloseText = "";
  }

  showCloseAccountModal (accountId: number): void {
    this.selectedDrivewealthAccountId = accountId;
    this.showConfirmCloseModal = true;
  }

  confirmCloseAccount (): void {
    this.onCloseAccount(this.selectedDrivewealthAccountId);
  }

  onCloseAccount (accountId: number): void {
    this.closeAccountProcessing = true;
    const accountManagementType = this.drivewealthStore.accountManagementType(accountId);
    this.drivewealthStore.closeAccount(accountId, {
        closeReasonId: this.accountCloseReasonId === -1 ? null : this.accountCloseReasonId,
        otherCloseReason:  this.accountCloseReasonId === -1 ? this.customReasonText : null
      })
      .then(result => {
        this.signingDocumentStore.markDeleteSignature(this.documentKey(accountId));
        this.signingDocumentStore.removeSignedKey(accountManagementType);
        this.drivewealthStore.loadAccountIds({})
            .then(result => {
              if (this.drivewealthStore.accountIds.length < 1) {
                this.signingDocumentStore.markDeleteSignature(this.signingDocumentStore.drivewealthAccountSignatureDocumentKey);
                this.signingDocumentStore.setHsabDrivewealthAccountSignature(null);
              }
              this.drivewealthStore.loadAccountSummariesV2({force: true});
            });
        if (this.drivewealthStore.closeAccountLoaded) {
          this.isCloseButtonDisabled = true;
          useNotifierStore().setSuccess("Account was closed successfully.");
        }
      }).finally(() => {
        this.isCloseButtonDisabled = false;
        this.closeAccountProcessing = false;
        this.onModalClose();
      });
  }

  get showAccountCloseReason (): boolean {
    return this.featureFlagStore.flags.bend24348HSAClosureReason;
  }

}

